import { ReactElement, useEffect, useRef, useState } from 'react';

import { SelectDatesTooltip } from '@app/components/atoms/select-dates-tooltip';

import {
    UseForceDatesSelectionParams,
    UseForceDatesSelectionReturn,
} from './listing-search-bar.props';

export const useForceDatesSelection = ({
    isInitialDataLoaded,
    dates,
    isDrawerOpen,
}: UseForceDatesSelectionParams): UseForceDatesSelectionReturn => {
    const forceDatesSelection =
        isInitialDataLoaded && (!dates?.checkInDate || !dates?.checkOutDate);

    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    const forceDatesSelectionRef = useRef(forceDatesSelection);
    const hasDrawerBeenOpenedRef = useRef(false);

    useEffect(() => {
        forceDatesSelectionRef.current = forceDatesSelection;
    }, [forceDatesSelection]);

    useEffect(() => {
        if (isDrawerOpen) {
            hasDrawerBeenOpenedRef.current = true;
            setIsTooltipOpen(false);
        } else if (hasDrawerBeenOpenedRef.current && forceDatesSelectionRef.current) {
            // Defer to avoid competing with the drawer closing animation
            const reopenTooltipTimeout = setTimeout(() => setIsTooltipOpen(true), 300);
            return () => clearTimeout(reopenTooltipTimeout);
        }
    }, [isDrawerOpen]);

    const mobileTriggerWrapper = forceDatesSelection
        ? (trigger: ReactElement) => (
              <SelectDatesTooltip open={isTooltipOpen} onOpenChange={setIsTooltipOpen}>
                  {trigger}
              </SelectDatesTooltip>
          )
        : undefined;

    return { forceDatesSelection, mobileTriggerWrapper };
};
